import type { Signal } from '@angular/core';
import { inject, Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Dispatch } from '@ngxs-labs/dispatch-decorator';

import { QUALTRICS_SURVEY_TYPES } from '../../helpers/qualtrics-feedback.constants';
import {
  QualtricsSurvey,
  QualtricsSurveyDefinition,
  QualtricsSurveySubmit,
} from '../../models';
import {
  LoadQualtricsSurveyDetails,
  SubmitQualtricsSurvey,
} from '../actions/qualtrics-survey-feedback.actions';
import { QualtricsFeedbackSelectors } from '../selectors';

@Injectable({ providedIn: 'root' })
export class QualtricsSurveyFeedbackStoreService {
  private readonly store = inject(Store);

  submitFeedbackErrorFor(surveyType: string): Signal<boolean> {
    return this.store.selectSignal(
      QualtricsFeedbackSelectors.submitFeedbackError(surveyType),
    );
  }

  submitFeedbackValidationErrorFor(surveyType: string): Signal<boolean> {
    return this.store.selectSignal(
      QualtricsFeedbackSelectors.submitFeedbackValidationError(surveyType),
    );
  }

  submitFeedbackSuccessFor(surveyType: string): Signal<boolean> {
    return this.store.selectSignal(
      QualtricsFeedbackSelectors.submitFeedbackSuccess(surveyType),
    );
  }

  qualtricsSurveyDefinitionFor(
    surveyType: string,
  ): Signal<QualtricsSurveyDefinition | null> {
    return this.store.selectSignal(
      QualtricsFeedbackSelectors.surveyDefinitionFor(surveyType),
    );
  }

  qualtricsSurveyFor(surveyType: string): Signal<QualtricsSurvey | null> {
    return this.store.selectSignal(
      QualtricsFeedbackSelectors.surveyFor(surveyType),
    );
  }

  isFeedbackEnabledFor(surveyType: string): Signal<boolean> {
    return this.store.selectSignal(
      QualtricsFeedbackSelectors.isFeedbackEnabledFor(surveyType),
    );
  }

  @Dispatch()
  loadQualtricsSurveyDetails = (
    surveyType: string = QUALTRICS_SURVEY_TYPES.ALWAYS_ON,
  ) => new LoadQualtricsSurveyDetails(surveyType);

  @Dispatch()
  onSubmitQualtricsSurveyFeedback = (
    surveyType: string,
    payload: QualtricsSurveySubmit,
  ) => new SubmitQualtricsSurvey(surveyType, payload);
}
